import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseKey) {
  throw new Error(
    'Thiếu biến môi trường Supabase.\n' +
    'Hãy thêm REACT_APP_SUPABASE_URL và REACT_APP_SUPABASE_ANON_KEY vào file .env'
  );
}

export const supabase = createClient(supabaseUrl, supabaseKey);
